'use client';

import Link from 'next/link';
import { Envelope, Headphones } from 'phosphor-react';
import { CONTACT_CTA } from '@/lib/constants';
import { useTranslations } from '@/app/providers';
import { Button } from '@/components/ui/button';
import { pushGTMEvent } from '@/lib/utils';
import { SectionHeader } from '@/components/common/section-header';

export function ContactSection() {
  const t = useTranslations();

  const handleEmailClick = () => {
    pushGTMEvent('click_cta_email', {
      cta_type: 'email',
      cta_location: 'contact_section',
    });
  };

  const handleCallClick = () => {
    pushGTMEvent('click_cta_call', {
      cta_type: 'call',
      cta_location: 'contact_section',
    });
  };

  return (
    <section id='contatti' className='relative w-full mt-16 md:mt-0 pt-12 md:pt-16 pb-0 z-20'>
      <div className='container mx-auto px-6 lg:px-0'>
        <div className='relative rounded-2xl overflow-hidden bg-brand-blue p-8 md:p-12 lg:p-16 translate-y-10'>
          <div className='relative z-10 flex flex-col gap-12 md:gap-10 items-center text-center'>
            <SectionHeader label={t.contact.label} title={t.contact.title} variant='light' />

            <p className='text-brand-violet-50 text-base md:text-lg leading-relaxed max-w-2xl'>
              {t.contact.description}
            </p>

            <div className='flex flex-col md:flex-row gap-4 pt-4 md:justify-center md:w-auto w-full'>
              {/* Email button - opens mailto */}
              <Button variant="outline-light" asChild className='w-full md:w-auto'>
                <Link 
                  href={CONTACT_CTA.email.href}
                  onClick={handleEmailClick}
                  aria-label={t.contact.emailAriaLabel}
                >
                  <Envelope aria-hidden='true' />
                  {t.contact.emailButton}
                </Link>
              </Button>

              {/* Call button - opens external Cal.com in new tab */}
              <Button variant="light" asChild className='w-full md:w-auto'>
                <a 
                  href={CONTACT_CTA.call.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleCallClick}
                  aria-label={`${t.contact.callAriaLabel} (si apre in una nuova finestra)`}
                >
                  <Headphones aria-hidden='true' />
                  {t.contact.callButton}
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
